import React, { useEffect, useState } from "react";
// import { ReactComponent as Logo } from "../../assets/images/newTelesecure360Logo-white.svg";
// import { ReactComponent as PurpleLogo } from "../../assets/images/newTeleSecure360logo.svg";
import { ReactComponent as Logo } from "../../assets/images/newTeleLogoWhite.svg";
import { ReactComponent as PurpleLogo } from "../../assets/images/newTeleLogo.svg";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Rodal from "rodal";
import { ReactComponent as Home } from "../../assets/icons/Category.svg";
import { ReactComponent as User } from "../../assets/icons/Add_User.svg";
import { ReactComponent as Document } from "../../assets/icons/Document.svg";
import { ReactComponent as Calendar } from "../../assets/icons/Calendar.svg";
import { RiStethoscopeFill } from "react-icons/ri";
import { AiOutlineMedicineBox } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";
import { RxCross2 } from "react-icons/rx";
import NewHome2 from "../../pages/Dashboard/NewHome2";

const NewHeader = (props) => {
  const navigate = useNavigate();

  const [isScrolled, setIsScrolled] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const token = localStorage.getItem("token");
  // const isGuest = localStorage.getItem("loggedInAsGuest") === "true";
  const isGuest = localStorage.getItem("loggedInAsGuest") === null ? null : localStorage.getItem("loggedInAsGuest") === "true";

  const isLoggedInUser = token && !isGuest;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [visible, setvisible] = useState(false);

  const user = localStorage.getItem("userData");
  const UserInfo = JSON.parse(user);
  const userImage = UserInfo?.profilePic?.original;
  const name = UserInfo?.firstName;

  const [showSidebar, setshowSidebar] = useState(true);
  const [userToggled, setUserToggled] = useState(false);

  const location = useLocation();
  const currentPath = location.pathname;
  const userEmail = localStorage.getItem("emailUser");

  const defaultClass = `transition duration-700 ease-in-out ${showSidebar ? "pl-8" : ""}  py-1 rounded-lg hover:text-primary ${isScrolled ? "text-bluishPurple" : "text-black"}`;

  const activeClass = `transition duration-700 ease-in-out ${showSidebar ? "pl-8" : ""} py-1 rounded-lg font-bold ${isScrolled ? "text-white" : "text-primary"}`;

  const NavLinkClass = `flex ${showSidebar ? "" : "justify-center"}  items-center`;

  const LinkData = [
    // { title: "Home", path: "/home/home2", icon: <Home /> },
    { title: "Home", path: "/", icon: <Home /> },
    { title: "My Appointments", path: "/appointment", icon: <Calendar /> },
    {
      title: "My Orders",
      path: "/order",
      icon: <AiOutlineMedicineBox className="text-sm" />,
    },
    { title: "My Profile", path: "/profile", icon: <User /> },
    { title: "My Documents", path: "/documents", icon: <Document /> },
    {
      title: "Intake Form",
      path: "/clinical",
      icon: <RiStethoscopeFill className="text-sm font-normal" />,
    },
    {
      title: "Resources",
      path: "/resources",
    },
  ];

  const LinkDataForGuest = [
    // { title: "Home", path: "/home/home2", icon: <NewHome2 /> },
    { title: "Home", path: "/", icon: <NewHome2 /> },
  ];

  const handleChange = (event) => {
    setAuth(event.target.checked);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const Logout = () => {
    setAnchorEl(null);

    localStorage.clear();
    navigate("/login");
    setvisible(true);
  };

  const ConfirmLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    navigate("/");
  };

  return (
    <div
      className={`${isScrolled ? "bg-darkPrimary" : ""
        } p-4 flex items-center sticky top-0 z-30 w-full`}
    >
      <div className="w-32">
        {/* {isScrolled ? <Logo /> : <PurpleLogo className="h-10 w-auto" />} */}
        {isScrolled ? <Logo className="h-10 w-auto" /> : <PurpleLogo className="h-10 w-auto" />}
      </div>

      <div className="hidden lg:flex flex-1 justify-center">
        <div
          className="flex items-center rounded-full gap-2 "
          style={{ backgroundColor: "#DBEEFA" }}
        >
          {(isLoggedInUser ? LinkData : LinkDataForGuest).map((item, i) => {
            // const isActive = currentPath.startsWith(item.path);
            const isActive = item.path === "/" ? currentPath === "/" : currentPath.startsWith(item.path);

            return (
              <NavLink
                key={i}
                to={item.path}
                className={`px-4 py-4 rounded-full text-base font-medium transition-all duration-300
            ${isActive ? "text-white bg-primary" : "text-dark"}`}
              >
                {item.title}
              </NavLink>
            );
          })}
        </div>
      </div>

      <div className="flex items-center gap-4 ml-auto">
        <div className="hidden lg:block">
          {user ? (
            <div
              onClick={Logout}
              style={
                isScrolled
                  ? {}
                  : {
                    background:
                      "linear-gradient(to bottom, #9A72C9 0%, #9A72C9 30%, #F4C4EE 100%)",
                  }
              }
              className={`${isScrolled ? "text-primary bg-white" : "text-white"
                } ${!isScrolled
                  ? "border-l border-r border-b border-primary border-t-0"
                  : ""
                } flex justify-center items-center rounded-full py-2 px-5`}
            >
              Sign out
            </div>
          ) : (
            <button
              onClick={() => navigate("/login")}
              style={
                isScrolled
                  ? {}
                  : {
                    background:
                      "linear-gradient(to bottom, #9A72C9 0%, #9A72C9 30%, #F4C4EE 100%)",
                  }
              }
              className={`${isScrolled ? "text-primary bg-white" : "text-white"
                } ${!isScrolled
                  ? "border-l border-r border-b border-primary border-t-0"
                  : ""
                } flex justify-center items-center rounded-full py-2 px-5`}
            >
              Login
            </button>
          )}
        </div>

        <div
          className="lg:hidden  cursor-pointer"
          onClick={() => setIsSidebarOpen(true)}
        >
          <GiHamburgerMenu
            className={`text-lg  ${!isScrolled ? "text-primary" : "text-white"}`}
          />
        </div>
      </div>

      {
        <div
          className={`fixed inset-0 z-50 flex justify-end transition-opacity duration-300 ${isSidebarOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
            }`}
        >
          <div
            className="absolute inset-0 bg-black transition-opacity duration-300"
            style={{ opacity: isSidebarOpen ? 0.4 : 0 }}
            onClick={() => setIsSidebarOpen(false)}
          />

          <div
            className={`relative bg-white w-64 h-full shadow-lg p-6 z-50 transform transition-transform duration-300 ease-in-out ${isSidebarOpen ? "translate-x-0" : "translate-x-full"
              }`}
          >
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-lg font-semibold"></h2>
              <span
                className="cursor-pointer "
                onClick={() => setIsSidebarOpen(false)}
              >
                <RxCross2 className="text-lg text-primary" />
              </span>
            </div>

            {/* Links */}
            <div className="flex flex-col gap-4">
              {(isLoggedInUser ? LinkData : LinkDataForGuest).map((item, i) => {
                const isActive = currentPath.startsWith(item.path);

                return (
                  <div
                    key={i}
                    onClick={() => {
                      navigate(item.path);
                      setIsSidebarOpen(false);
                    }}
                    className={`cursor-pointer px-4 py-2 rounded-lg transition ${isActive
                      ? "bg-primary text-white"
                      : "text-black hover:bg-gray-100"
                      }`}
                  >
                    {item.title}
                  </div>
                );
              })}
            </div>

            {/* Login / Logout */}
            <div className="mt-8">
              {user ? (
                <div
                  onClick={Logout}
                  className="bg-primary text-white px-4 py-2 rounded-lg text-center cursor-pointer border-l border-r border-b border-primary border-t-0"
                  style={{
                    background:
                      "linear-gradient(to bottom, #9A72C9 0%, #9A72C9 30%, #F4C4EE 100%)",
                  }}
                >
                  Sign out
                </div>
              ) : (
                <div
                  onClick={() => {
                    navigate("/login");
                    setIsSidebarOpen(false);
                  }}
                  className="bg-primary text-white px-4 py-2 rounded-lg text-center cursor-pointer border-l border-r border-b border-primary border-t-0"
                  style={{
                    background:
                      "linear-gradient(to bottom, #9A72C9 0%, #9A72C9 30%, #F4C4EE 100%)",
                  }}
                >
                  Login
                </div>
              )}
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default NewHeader;
